import $ from 'jquery';
import getGaClientId from '../../common/get_ga_client_id';
import EventBus from '../../common/EventBus';

const API_ENDPOINTS = {
  updateQuote: '/bookings/update-quote',
};

const TIMING = {
  debounceDelay: 1000,        // milliseconds
  pollRetryDelay: 3000,       // milliseconds
};

const HTTP_STATUS = {
  accepted: 202,  // Request accepted and being processed
};

export default class QuoteService {
  constructor(selectedJobsState) {
    this.selectedJobsState = selectedJobsState;
    this.getQuoteTimeout = null;
    this.getQuoteRequest = null;
    this.debouncedGetQuote = $.debounce(TIMING.debounceDelay, () => {
      this.getQuote();
    });
  }

  getQuote() {
    this.executeQuote((success, error) => {
      return $.ajax({
        url: API_ENDPOINTS.updateQuote,
        type: 'POST',
        data: {
          work_items: this.selectedJobsState.ids(),
          booking: { ga_client_id: getGaClientId() },
        },
        success: success,
        error: error,
      });
    });
  }

  executeQuote(requestHandler) {
    // Stop any lined-up requests and abort any requests that are currently running
    // so we don't return outdated information
    clearTimeout(this.getQuoteTimeout);
    if (this.getQuoteRequest) {
      this.getQuoteRequest.abort();
    }

    this._startFetchingQuote();

    this.getQuoteRequest = requestHandler(
      (data, status, jqXHR) => this._handleQuoteSuccess(data, status, jqXHR),
      (data) => this._handleQuoteError(data),
    );
  }

  _handleQuoteSuccess(data, status, jqXHR) {
    if (jqXHR.status === HTTP_STATUS.accepted) {
      this.getQuoteTimeout = setTimeout(() => this.getQuote(), TIMING.pollRetryDelay);
      return;
    }

    if (data.redirect) {
      this._redirectTo(data.redirect);
      return;
    }

    EventBus.emit('quote:updated', { quote: data });
    this._endFetchingQuote(data);
  }

  _handleQuoteError(data) {
    // Make sure we don't go into the error callbacks for aborted calls
    if (data.statusText !== 'abort') {
      EventBus.emit('quote:error', { error: data });
    }

    this._endFetchingQuote(data);
  }

  _startFetchingQuote() {
    EventBus.emit('quote:fetching-start', {});
  }

  _endFetchingQuote(data) {
    EventBus.emit('quote:fetching-end', { quote: data });
  }

  _redirectTo(path) {
    window.location.assign(path);
  }
}
